import create from 'zustand'

import { EmployeeStoreState, EmployeeTabs } from './types'
import { CompanyAndBu, EmployeeLevelEnum } from '../../types'
import { labelSorter } from '../../shared/sortUtils'
import { CascaderOptionType } from 'antd/lib/cascader'

const initialValues = {
  storeInitialized: false,
  companiesAndBu: [],
  companiesAndBuSelected: [],
  selected: { companyId: '', buId: '', isAllBu: false },
  activeTab: EmployeeTabs.Active,
  employeeLevels: [],
}

export const useEmployeeStore = create<EmployeeStoreState>((set) => ({
  ...initialValues,

  initStore: (_companiesAndBu: CompanyAndBu[], employeeLevels: EmployeeLevelEnum[]) =>
    set((state) => {
      const companiesAndBu = _companiesAndBu
        .map((company) => {
          return {
            companyId: company.companyId,
            companyName: company.companyName,
            bu: [...company.bu].sort((bu1, bu2) => labelSorter(bu1.displayName, bu2.displayName)),
          }
        })
        .sort((c1, c2) => labelSorter(c1.companyName, c2.companyName))

      const companiesAndBuSelected: CascaderOptionType[] = companiesAndBu.map((company) => ({
        label: company.companyName,
        value: `${company.companyId}`,
        children: company.bu
          ? company.bu.map((bu) => ({
              label: bu.displayName,
              value: `${bu.buId}`,
            }))
          : undefined,
      }))

      const selected = {
        companyId: state.selected.companyId || companiesAndBu[0].companyId,
        buId: state.selected.buId || companiesAndBu[0].bu[0].buId,
        isAllBu: !!state.selected.companyId && !!state.selected.buId ? state.selected.isAllBu : companiesAndBu[0].bu[0].isAllBu,
      }

      return { storeInitialized: true, companiesAndBu, companiesAndBuSelected, selected, employeeLevels }
    }),

  setActiveTab: (activeTab: EmployeeTabs) => set({ activeTab }),

  setSelected: (companyId: string, buId: string) =>
    set((state) => {
      const company = state.companiesAndBu.find((cbu) => cbu.companyId === companyId)

      if (!!company) {
        const bu = company.bu.find((bu) => bu.buId === buId)
        return { selected: { companyId, buId, isAllBu: !!bu ? bu.isAllBu : false } }
      }

      return { ...state }
    }),
}))
